import * as Sentry from '@sentry/react';

// Phase H: Sentry is wired but inert until a DSN is provided. No DSN env →
// init() is never called → zero network, zero data leaves the browser. This
// keeps local/dev and credential-less CI completely silent while making
// production opt-in a single env var.
//
// Privacy: Session Replay masks ALL text and inputs and blocks ALL media, so
// no reader content or PII is ever captured even when Replay is enabled.
export function initSentry(): void {
  const dsn = import.meta.env.PUBLIC_SENTRY_DSN;
  if (!dsn) return;

  Sentry.init({
    dsn,
    environment: import.meta.env.PUBLIC_SENTRY_ENVIRONMENT ?? import.meta.env.MODE,
    release: import.meta.env.PUBLIC_SENTRY_RELEASE,
    tracesSampleRate: 0.1,
    replaysSessionSampleRate: 0.1,
    replaysOnErrorSampleRate: 1.0,
    integrations: [
      Sentry.browserTracingIntegration(),
      Sentry.replayIntegration({
        maskAllText: true,
        maskAllInputs: true,
        blockAllMedia: true,
      }),
    ],
  });
}

export { Sentry };
